export const createUiSlice = (set, get) => ({
    currentStep: "schedule",
    feeAudience: null,
    bookingRevision: 0,
    setStep: (step) => set({ currentStep: step }),
    setFeeAudience: (audience) => set({ feeAudience: audience }),
    goBack: () => {
        const { currentStep, otpVerified } = get();
        const backMap = {
            phone: "schedule",
            otp: "phone",
            "patient-selection": otpVerified ? "schedule" : "otp",
            summary: "patient-selection",
            "payment-pending": "summary",
        };
        const prev = backMap[currentStep];
        if (prev) {
            set({ currentStep: prev, bookingError: null });
        }
    },
    bumpBookingRevision: () => set((state) => ({ bookingRevision: state.bookingRevision + 1 })),
});
